import useSubmitReceivingSignature from "../../requests/Receiving/useSubmitReceivingSignature";
import KaSignatureOrientation from "../Signature/KaSignatureOrientation";

interface ReceivingSignatureProps {
  stagedPurchaseOrderId: string,
  signatureSubmitted: (emailTickets: boolean, userEmail?: string) => void,
  devToolItems?: React.ReactNode,
}

const ReceivingSignature = (props: ReceivingSignatureProps) => {
  const submitSignature = useSubmitReceivingSignature(props.stagedPurchaseOrderId, {
    onSuccess: ({ emailTickets, userEmail }) =>
      props.signatureSubmitted(emailTickets, userEmail),
  });

  return <KaSignatureOrientation
    submitSignature={submitSignature}
    devToolItems={props.devToolItems} />
}

export default ReceivingSignature;